import React from 'react';
import AboutTab from '../components/AboutTab';

export default function About() {
  return <AboutTab />;
}
